export const getIsSportsBet = () => {
  const url = new URL(window.location.href)
  if (url.pathname.includes('odn_oddingame') || url.pathname.includes('btsg_sportbetting')) {
    return true
  }
  return false
}

export default { getIsSportsBet }
